import type { ComponentDefinition, Terminal } from "../types";

function post(id: string, label: string, polarity: Terminal["polarity"], direction: Terminal["direction"], side: Terminal["side"], offset: number, maxAmp = 0): Terminal {
  return { id, label, polarity, direction, side, offset, maxAmp };
}

export const PV_COMBINERS: ComponentDefinition[] = [
  {
    // Generic copper layout, not an assertion that a specific enclosure fits
    // three 10×38 holders. MNPV3, for example, holds only TWO fused strings:
    // https://www.midnitesolar.com/pdfs/pvCombiner_spec_sheet.pdf
    // https://www.midnitesolar.com/pdfs/MNPV3_6_REV-H_10-010-1__manual.pdf
    id: "dist-pv-combiner-3",
    name: "Three-String PV Combiner",
    shortName: "PV combiner · 3 strings",
    subtitle: "Separate PV + / − buses; string fuses drawn separately",
    category: "distribution", width: 240, height: 230,
    terminals: [
      ...[1, 2, 3].flatMap((index) => [
        post(`pv${index}-pos`, `STRING ${index} +`, "positive", "input", "left", (index * 2 - 1) / 7),
        post(`pv${index}-neg`, `STRING ${index} −`, "negative", "input", "left", index * 2 / 7),
      ]),
      post("pv-out-pos", "PV OUT +", "positive", "output", "right", 0.35),
      post("pv-out-neg", "PV OUT −", "negative", "output", "right", 0.7),
    ],
    // Each incoming string reaches only its own-polarity common bus.
    // Protection is provided by separately drawn gPV holders before these
    // inputs; no fuse is silently invented inside this generic combiner.
    simulateStates: {
      default: "connected",
      options: [{
        id: "connected", label: "Connected",
        intraLinks: [1, 2, 3].flatMap((index): [string, string][] => [
          [`pv${index}-pos`, "pv-out-pos"], [`pv${index}-neg`, "pv-out-neg"],
        ]),
      }],
    },
  },
  {
    // LPHV001: one pole, 30 A maximum, 1000 V DC, NOT load-break rated.
    // Littelfuse POWR-GARD catalog p182:
    // https://www.littelfuse.com/assetdocs/powr-gard-catalog?assetguid=85d36235-a32b-4608-bfed-f9878aa43af0
    id: "dist-holder-gpv",
    image: "dist-holder-gpv.webp",
    name: "Littelfuse LPHV001 gPV String Fuse Holder",
    shortName: "gPV holder · 10×38",
    subtitle: "PV fuse holder, 30A / 1000V DC; fuse selected separately",
    category: "distribution", manufacturer: "Littelfuse", model: "LPHV001",
    renderVariant: "fuse-holder", isFuseBlock: true, fuseSlotType: "gPV",
    equipmentLimitExemption: "fuse", width: 90, height: 36,
    terminals: [
      post("in", "STRING +", "positive", "input", "left", 0.5, 30),
      post("out", "BUS +", "positive", "output", "right", 0.5, 30),
    ],
  },
];

export const PV_HOLDER_MAX_VDC = 1000;
